import { css } from 'lit';

import { narrow, stacked } from '../media.js';

export const revisionEditorPageStyles = css`
  form {
    display: grid;
    gap: var(--column-gap);
    grid-template-columns: var(--columns-aside-main);
    align-items: start;
  }

  @media ${stacked} {
    form {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .buttons {
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    position: sticky;
    bottom: var(--bottom-overlay);
    /* Clear of the home indicator, unless the update prompt already covers it. */
    padding: var(--space-3) 0 calc(var(--space-3) + max(0px, var(--safe-bottom) - var(--bottom-overlay)));
    border-top: var(--border-width) solid var(--border);
    background: var(--background);
  }

  .buttons .hint {
    margin-left: auto;
    color: var(--text-muted);
    font-size: var(--font-size-md);
  }

  textarea {
    min-height: var(--textarea-min-height);
  }

  form section + section {
    margin-top: 0;
  }

  .assistants {
    grid-column: 1 / -1;
    display: grid;
    gap: var(--space-4);
  }

  .assistant {
    display: grid;
    gap: var(--space-4);
    grid-template-columns: var(--columns-aside-main);
    align-items: start;
    padding: var(--space-4);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
  }

  @media ${stacked} {
    .assistant {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .assistant > h3 {
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2);
    margin: 0;
  }

  /* Where the assistant stands in the team, under its name. */
  .assistant > .role {
    grid-column: 1 / -1;
    margin: 0;
    color: var(--text-muted);
  }

  /* Name, template and button on one line (the controls are as tall as each other, formStyles);
     the id below. */
  .add {
    display: grid;
    grid-template-columns: minmax(0, 3fr) minmax(0, 2fr) auto;
    align-items: end;
    gap: var(--space-2) var(--space-3);
  }

  .add.no-template {
    grid-template-columns: minmax(0, 3fr) auto;
  }

  .add .field {
    margin-bottom: 0;
  }

  .add > .help {
    grid-column: 1 / -1;
    margin: 0;
    color: var(--text-muted);
    font-size: var(--font-size-md);
  }

  @media ${narrow} {
    .add,
    .add.no-template {
      grid-template-columns: minmax(0, 1fr);
    }

    .add > button {
      justify-self: start;
    }
  }
`;
